export default __webpack_public_path__ + "static/media/studio-4.4c272c46.jpg";